<template>
  <div
    :class="useBoxedWidth ? 'container p-0' : 'layout-full-bleed'"
  >
    <transition
      name="page-fade"
      mode="out-in"
    >
      <!-- layoutKey (défini en meta) permet de garder un shell monté à travers
           ses routes enfant (ex: console admin) et d'éviter le flash blanc.
           À défaut, on garde l'ancien comportement (clé = chemin complet). -->
      <router-view :key="$route.meta.layoutKey || $route.path" />
    </transition>
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'

export default {
  computed: {
    useBoxedWidth() {
      if (this.$route && String(this.$route.path || '').startsWith('/classroom-addon')) {
        return false
      }
      return this.contentWidth === 'boxed'
    },
  },
  setup() {
    const { contentWidth } = useAppConfig()
    return { contentWidth }
  },
}
</script>

<style>
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity 0.3s ease;
}
.page-fade-enter,
.page-fade-leave-to {
  opacity: 0;
}

.layout-full-bleed {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
}
</style>
